"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GridImagePicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@dnd-kit/core");
var _sortable = require("@dnd-kit/sortable");
var _box = require("@oneloop/box");
var _ImageItem = _interopRequireDefault(require("./ImageItem"));
var _useGridImagePicker2 = _interopRequireDefault(require("./hooks/useGridImagePicker"));
require("../styles/GridImagePicker.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * A grid-based image picker component with sortable and selectable images.
 *
 * @param {Object} props - The props for GridImagePicker.
 * @param {string[]} props.listOfSrc - Array of image URLs to display in the grid.
 * @param {number} [props.maxSelectablePreferenceByUser=10] - Maximum number of images that can be selected by the user.
 *        Default is 10. This value is a preference; if there are fewer images available than this number, it will adjust accordingly.
 * @param {number} [props.maxSizeInMB=8] - Maximum size in megabytes for each image. Default is 8 MB. Images exceeding this limit will be marked as an error.
 * @param {number} [props.minAspectRatio] - Minimum aspect ratio allowed for the images. Images that don't meet this ratio will be marked as an error.
 * @param {number} [props.maxAspectRatio] - Maximum aspect ratio allowed for the images. Images that exceed this ratio will be marked as an error.
 * @param {Function} [props.onChange] - Optional callback function invoked whenever the internal state of images changes.
 *        Called with the updated list of items as `(items) => onChange(items)`.
 * @param {Function} [props.sizeFetcher] - Optional fetch function to get the size of the images. Default: (src) => fetch(src)
 * @param {Object} props.texts - Nested texts
 */
var GridImagePicker = exports.GridImagePicker = function GridImagePicker(_ref) {
  var listOfSrc = _ref.listOfSrc,
    _ref$maxSelectablePre = _ref.maxSelectablePreferenceByUser,
    maxSelectablePreferenceByUser = _ref$maxSelectablePre === void 0 ? 10 : _ref$maxSelectablePre,
    _ref$maxSizeInMB = _ref.maxSizeInMB,
    maxSizeInMB = _ref$maxSizeInMB === void 0 ? 8 : _ref$maxSizeInMB,
    minAspectRatio = _ref.minAspectRatio,
    maxAspectRatio = _ref.maxAspectRatio,
    onChange = _ref.onChange,
    _ref$onEdit = _ref.onEdit,
    onEdit = _ref$onEdit === void 0 ? null : _ref$onEdit,
    texts = _ref.texts,
    sizeFetcher = _ref.sizeFetcher;
  var _useGridImagePicker = (0, _useGridImagePicker2["default"])({
      listOfSrc: listOfSrc,
      maxSelectablePreferenceByUser: maxSelectablePreferenceByUser,
      maxSizeInMB: maxSizeInMB,
      minAspectRatio: minAspectRatio,
      maxAspectRatio: maxAspectRatio,
      onChange: onChange
    }),
    attributes = _useGridImagePicker.attributes,
    methods = _useGridImagePicker.methods;
  var items = attributes.items,
    config = attributes.config,
    status = attributes.status;
  var handleClickItem = methods.handleClickItem,
    handleUpdateItem = methods.handleUpdateItem,
    handleDeselectAll = methods.handleDeselectAll,
    handleSelectAll = methods.handleSelectAll,
    handleDragStart = methods.handleDragStart,
    handleDragEnd = methods.handleDragEnd;
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.MouseSensor, {
    activationConstraint: {
      distance: 10
    }
  }));
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "gridImagePickerContainer"
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "gridButtonsWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "button",
    className: "gridButton gridButtonSelect",
    onClick: handleSelectAll,
    disabled: status.numberOfCheckedItems === config.maxSelectable || !status.itemsAreReady
  }, "Seleccionar ", status.itemsAreReady ? config.maxSelectable : 0), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "button",
    className: "gridButton gridButtonDeselect",
    onClick: handleDeselectAll,
    disabled: status.numberOfCheckedItems === 0
  }, "Deseleccionar todos")), /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
    sensors: sensors,
    collisionDetection: _core.closestCenter,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    autoScroll: false
  }, /*#__PURE__*/_react["default"].createElement(_sortable.SortableContext, {
    items: items,
    strategy: _sortable.rectSortingStrategy
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "section",
    className: "gridImagePicker"
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_ImageItem["default"], {
      key: item.id,
      item: item,
      status: status,
      config: config,
      handleClick: handleClickItem,
      onEdit: onEdit,
      handleUpdateItem: handleUpdateItem,
      texts: texts,
      sizeFetcher: sizeFetcher
    });
  })))));
};
var _default = exports["default"] = GridImagePicker;